import { TaxInvoiceLogRequest, TaxInvoiceLogResponse } from 'routes/main/taxInvoice/types';

export const TAX_INVOICE_LOG_REQUEST = 'TAX_INVOICE_LOG_REQUEST';
export const TAX_INVOICE_LOG_SUCCESS = 'TAX_INVOICE_LOG_SUCCESS';
export const TAX_INVOICE_LOG_ERROR = 'TAX_INVOICE_LOG_ERROR';
export const TAX_INVOICE_LOG_RESET = 'TAX_INVOICE_LOG_RESET';

export interface TaxInvoiceLogRequestAction {
  type: typeof TAX_INVOICE_LOG_REQUEST;
  payload: TaxInvoiceLogRequest;
}

export interface TaxInvoiceLogSuccessAction {
  type: typeof TAX_INVOICE_LOG_SUCCESS;
  payload: TaxInvoiceLogResponse;
}

export interface TaxInvoiceLogErrorAction {
  type: typeof TAX_INVOICE_LOG_ERROR;
  payload: {
    message: string;
    error?: any;
  };
}

export interface TaxInvoiceLogResetAction {
  type: typeof TAX_INVOICE_LOG_RESET;
}

export type AuditLogAction =
  | TaxInvoiceLogRequestAction
  | TaxInvoiceLogSuccessAction
  | TaxInvoiceLogErrorAction
  | TaxInvoiceLogResetAction;
